import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { TableData } from '../common/components/TableData';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import CircularProgress from '@material-ui/core/CircularProgress';

export class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inProcess: false,
      adminDialog: false,
      dialogAction: '',
      dialogTitle: '',
      name: '',
      logoUrl: '',
      orgDelete: '',
      selectedItem: {},
      showDeleteError: false,
      fetchState: ApiHelperV2.State.LOADING,
      formFieldsValidity: {
        name: true,
        logoUrl: true,
      },
      formFieldErrMsg: {
        name: '*Required',
        logoUrl: '*Required',
      }
    }
    this.orgFields = {
      name: {
        key: 'name',
        label: 'Name',
        type: 'text'
      },
      logoUrl: {
        key: 'logoUrl',
        label: 'Organisation logo link',
        type: 'text'
      },
      orgDelete: {
        key: 'orgDelete',
        label: 'Type DELETE',
        type: 'text'
      }
    };
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['orgs']) },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          orgsItem: results,
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }

  add = () => {
    this.setState({
      adminDialog: true,
      dialogAction: 'add',
      dialogTitle: 'Add organisation',
      selectedItem: {},
      name: '',
      logoUrl: ''
    })
  }

  edit = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'edit',
      dialogTitle: 'Edit organisation',
      selectedItem: item,
      name: item.name,
      logoUrl: item.logoUrl
    })
  }

  delete = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'delete',
      dialogTitle: 'Delete organisation',
      selectedItem: item,
      name: item.name,
      logoUrl: item.logoUrl
    })
  }

  users = (item) => {
    this.props.history.push({ pathname: '/admin/orgs/' + item._id + '/users', state: { item: item } })
  }

  places = (item) => {
    this.props.history.push({ pathname: '/admin/orgs/' + item._id + '/places', state: { item: item } })
  }

  dialogCloseValidation = () => {
    const formFieldsValidity = this.state.formFieldsValidity;
    formFieldsValidity.name = true;
    formFieldsValidity.logoUrl = true;

    this.setState({
      formFieldsValidity: formFieldsValidity
    });
  }

  dialogClose = () => {
    const apiBody = this.dialogCloseValidation()
    this.setState({
      adminDialog: false,
      errMsg: '',
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      name: '',
      logoUrl: '',
      showDeleteError: false,
    })
  }

  validateFields = () => {
    const item = this.state;
    const formFieldsValidity = this.state.formFieldsValidity;
    if (!item.name || item.name.length === 0) {
      formFieldsValidity.name = false;
    } else {
      formFieldsValidity.name = true;
    }
    if (!item.logoUrl || item.logoUrl.length === 0) {
      formFieldsValidity.logoUrl = false;
    } else {
      formFieldsValidity.logoUrl = true;
    }

    this.setState({
      formFieldsValidity: formFieldsValidity
    });

    for (const key in formFieldsValidity) {
      if (formFieldsValidity[key] === false) {
        return false
      }
    }

    const apiBody = {
      name: item.name,
      logoUrl: item.logoUrl,
    }
    return apiBody;
  }

  submitOrg = (id) => {
    const apiBody = this.validateFields();
    let options = {};
    if (apiBody) {
      this.setState({
        inProcess: true
      })
      if (!id) {
        options = {
          method: 'POST',
          endPoint: ApiHelperV2.makeUrlPath(['orgs']),
          jsonBody: {
            orgData: {
              name: this.state.name,
              logoUrl: this.state.logoUrl,
            }
          }
        }
      } else {
        options = {
          method: 'PUT',
          endPoint: ApiHelperV2.makeUrlPath(['orgs', id]),
          jsonBody: {
            orgData: {
              name: this.state.name,
              logoUrl: this.state.logoUrl,
            }
          }
        }
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            logoUrl: ''
          }), () => this.fetchItems());
        }
      }.bind(this))
    }
  }

  deleteOrg = (id) => {
    if (this.state.orgDelete === 'DELETE') {
      this.setState({
        inProcess: true
      })
      const options = {
        method: 'DELETE',
        endPoint: ApiHelperV2.makeUrlPath(['orgs', id]),
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            inProcess: false,
            errCode: err.respCode,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            logoUrl: '',
            showDeleteError: false,
          }), () => this.fetchItems());
        }
      }.bind(this))
    } else {
      this.setState({ showDeleteError: true })
    }
  }

  change = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  generateTextField = (formField, data) => {
    let disabled = '';
    let validity = {};
    validity = this.state.formFieldsValidity;

    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'orgDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    return (
      <TextField
        id={formField.key}
        label={formField.label}
        name={formField.key}
        className={css(Styles.inputCss)}
        value={data}
        onChange={e => this.change(e)}
        margin='normal'
        type={formField.type}
        helperText={this.state.dialogAction === 'delete' ? '' :
          validity[formField.key] ? '' : this.getFieldErrorMsg(formField.key)}
        error={this.state.dialogAction === 'delete' ? '' : !validity[formField.key]}
        disabled={disabled}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContentInput),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            focused: css(Styles.focused),
          }
        }}
      />
    )
  }

  renderDialog = (dialogAction, title) => {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.adminDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{title}</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.orgFields.name, this.state.name)}
            {this.generateTextField(this.orgFields.logoUrl, this.state.logoUrl)}
          </div>
          {dialogAction === 'delete' &&
            <div className={css(Styles.fieldsContainer)}>
              {this.generateTextField(this.orgFields.orgDelete)}
            </div>
          }
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            disabled={this.state.inProcess}
            variant='contained'
            onClick={this.state.dialogAction === 'delete' ? e => this.deleteOrg(this.state.selectedItem._id) :
              e => this.submitOrg(this.state.selectedItem._id)}
            className={css(Styles.actionButton)}>
            {this.state.dialogAction === 'delete' ? 'Delete' : 'Submit'}
            {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(CommonStyles.marginLeft)} />}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogClose()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.showDeleteError && this.state.dialogAction === 'delete' &&
          <p className={css(Styles.deleteMsg)}>*Enter DELETE Correctly</p>
        }
        {this.state.errMsg &&
          <p className={css(Styles.deleteMsg)}>{this.state.errMsg}</p>
        }
      </Dialog>
    );
  }

  render() {
    if (this.state.fetchState === ApiHelperV2.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelperV2.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <TableData
          titleIcon='account_balance'
          titleText='ORGANISATIONS'
          columnTitle={['Organisation ID', 'Name']}
          tableData={this.state.orgsItem}
          icons={[
            {
              title: 'create',
              funcName: 'editFunction'
            },
            {
              title: 'delete',
              funcName: 'deleteFunction'
            },
            {
              title: 'person',
              funcName: 'usersFunction'
            },
            {
              title: 'location_city',
              funcName: 'placesFunction'
            },
          ]}
          addFunction={this.add}
          editFunction={this.edit}
          deleteFunction={this.delete}
          usersFunction={this.users}
          placesFunction={this.places}
        />
        {this.renderDialog(this.state.dialogAction, this.state.dialogTitle)}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  inputCss: {
    margin: '5px 0px 10px 0px',
    flex: 1,
    color: '#757575'
  },
  dialog: {
    minWidth: 500,
    '@media(max-width: 767px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    borderBottom: '2px solid whitesmoke',
    padding: 20,
    backgroundColor: '#303E8A',
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 25,
    margin: 0,
    color: 'white'
  },
  dialogContent: {
    padding: '0px 20px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    textTransform: 'unset'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  textFieldContent: {
    color: '#757575',
  },
  focused: {
    color: '#3F51B5',
    fontWeight: 'bold'
  },
  deleteMsg: {
    margin: 20,
    marginTop: 0,
    fontWeight: 'bold',
    color: 'red',
    fontSize: 15
  },
})



// WEBPACK FOOTER //
// ./src/screens/Admin.js